import { Dropdown, Button } from "react-bootstrap";
import {
  ChevronLeft,
  ChevronRight,
  ChevronDoubleLeft,
  ChevronDoubleRight,
} from "react-bootstrap-icons";

const FalconPagination = ({
  currentPage, // zero-based
  rowsPerPage,
  totalRecords,
  onPageChange,
  onPageSizeChange,
}) => {
  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const startRecord = totalRecords === 0 ? 0 : currentPage * rowsPerPage + 1;
  const endRecord = Math.min((currentPage + 1) * rowsPerPage, totalRecords);

  const getVisiblePages = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 0; i < totalPages; i++) pages.push(i);
      return pages;
    }

    const lastTwo = [totalPages - 2, totalPages - 1];

    if (currentPage <= 0) {
      pages.push(0, 1, "ellipsis", ...lastTwo);
    } else if (currentPage === 2) {
      pages.push(2, 3, "ellipsis", ...lastTwo);
    } else if (currentPage >= totalPages - 3) {
      for (let i = totalPages - 4; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(currentPage, currentPage + 1, "ellipsis", ...lastTwo);
    }

    return pages;
  };

  return (
    <div className="d-flex justify-content-between mt-3 align-items-center flex-wrap gap-2">
      {/* Left Side: Rows per page & record range */}
      <div className="d-flex align-items-center gap-2">
        <span className="text-600 fs-10">Rows per page:</span>
        <Dropdown>
          <Dropdown.Toggle
            variant="link"
            size="sm"
            className="text-600 fs-10 p-0"
          >
            {rowsPerPage}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {[10, 50, 100, 200, 500, 1000].map((size) => (
              <Dropdown.Item
                key={size}
                onClick={() => onPageSizeChange(size)}
                active={rowsPerPage === size}
              >
                {size}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>

        <span className="text-600 fs-10">
          {totalRecords === 0
            ? "0"
            : `${startRecord}–${endRecord} of ${totalRecords}`}
        </span>
      </div>

      {/* Right Side: Pagination Controls */}
      <div className="d-flex gap-1 align-items-center flex-wrap">
        {/* First Page Button */}
        <Button
          size="sm"
          variant="falcon-default"
          disabled={currentPage === 0}
          onClick={() => onPageChange(0)}
        >
          <ChevronDoubleLeft size={14} />
        </Button>

        {/* Previous Page Button */}
        <Button
          size="sm"
          variant="falcon-default"
          disabled={currentPage === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <ChevronLeft size={14} />
        </Button>

        {/* Page Numbers */}
        {getVisiblePages().map((page, index) => {
          if (page === "ellipsis") {
            return (
              <Button
                key={`ellipsis-${index}`}
                size="sm"
                variant="falcon-default"
                disabled
              >
                ...
              </Button>
            );
          }

          return (
            <Button
              key={page}
              size="sm"
              variant={page === currentPage ? "primary" : "falcon-default"}
              onClick={() => onPageChange(page)}
            >
              {page + 1}
            </Button>
          );
        })}

        {/* Next Page Button */}
        <Button
          size="sm"
          variant="falcon-default"
          disabled={currentPage + 1 >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <ChevronRight size={14} />
        </Button>

        {/* Last Page Button */}
        <Button
          size="sm"
          variant="falcon-default"
          disabled={currentPage >= totalPages - 1}
          onClick={() => onPageChange(totalPages - 1)}
        >
          <ChevronDoubleRight size={14} />
        </Button>
      </div>
    </div>
  );
};

export default FalconPagination;
